import React from 'react';
import { View } from 'react-native';
import type { Meta, StoryObj } from '@storybook/react';

import { ChallengeCongratsFrame } from './ChallengeCongratsFrame';

const meta = {
  title: 'Challenges/ChallengeCongratsFrame',
  component: ChallengeCongratsFrame,
  args: {
    headline: 'Great start, see you tomorrow! 👋',
    days: [{ done: true }, { done: false }, { done: false }, { done: false }, { done: false }, { done: false }, { done: false }],
    designSystemColor: 'LAVENDER',
  },
  decorators: [
    Story => (
      <View style={{ width: 360, height: 560 }}>
        <Story />
      </View>
    ),
  ],
} satisfies Meta<typeof ChallengeCongratsFrame>;

export default meta;

type Story = StoryObj<typeof meta>;

export const DayOne: Story = {};

export const MidChallenge: Story = {
  args: {
    headline: 'You are on the right track, keep it up! 💪',
    days: [{ done: true }, { done: true }, { done: true }, { done: true }, { done: false }, { done: false }, { done: false }],
    designSystemColor: 'TURQUOISE',
  },
};

export const Completed: Story = {
  args: {
    headline: 'Challenge completed!',
    subtitle: 'Seven days of showing up for yourself.',
    completed: true,
    designSystemColor: 'PINK',
  },
};
